import { TestCase } from 'src/components/types/TestCase';
import {
    getTestcase,
    getTestExecutionTeller,
    initiatePaymentApi, METHOD_GET, METHOD_POST, updateCommentApi
} from 'src/components/constants/constants';
import {TestExecution} from "src/components/types/TestExecution";
import { getApiBaseUrl } from 'src/config/api';
import {makeApiRequest} from "src/components/helper/apiUtils";
const testPilotApi = getApiBaseUrl();

export const fetchTestCases = async (service: string, isExecution: boolean): Promise<TestCase[]> => {
    let typedItems: TestCase[] = [];

    try {
        //const response = await fetch(`${testPilotApi}${getTestcase}/${service}`);
        const response = await makeApiRequest(testPilotApi, METHOD_GET, `${getTestcase}/${service}`);
        const data = await response.json();
        if (data?.items && Array.isArray(data.items)) {
            typedItems = data.items.map((item: any) => ({
                ...item
            }));
        } else {
            console.log('Failed to fetch test cases.');
        }
    } catch (err) {
        console.log('An error occurred while fetching data.', err);
    }
    return typedItems;
};

export const fetchTestExecutions = async (testId: string, project: string): Promise<TestExecution[]> => {
    let typedItems: TestExecution[] = [];
    try {
        //const response = await fetch(`${testPilotApi}${getTestExecutionTeller}/${project}/${testId}`);
        const response = await makeApiRequest(testPilotApi, METHOD_GET, `${getTestExecutionTeller}/${project}/${testId}`);
        const data = await response.json();
        if (Array.isArray(data)) {
            typedItems = data;
        } else {
            console.log('No valid items in the response.');
        }
    } catch (err) {
        console.log('An error occurred while fetching data.', err);
    }
    return typedItems;
};

export const initiatePayment = async (service: string, testId: string) => {
    try {
        const payload = {
            serviceType: service,
            testId: testId
        };
       /*const res = await fetch(`${testPilotApi}${initiatePaymentApi}`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(payload)
        });*/
        const res = await makeApiRequest(testPilotApi, METHOD_POST, initiatePaymentApi, payload);

        return res;
    } catch (error) {
        console.error('Error initiating payment:', error);
        throw error;
    }
};

export const updateExecutionComment = async (
    apServiceId: string,
    comment: string
): Promise<boolean> => {
    try {
        /*const response = await fetch(`${testPilotApi}${updateCommentApi}`, {
            method: 'POST', // or 'PUT' based on backend
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                apServiceId,
                comment
            })
        });*/
        const response = await makeApiRequest(testPilotApi, METHOD_POST, updateCommentApi, {apServiceId,
            comment});
        if (!response.ok) {
            const errorText = await response.text();
            console.error('Failed to update comment:', errorText);
            return false;
        }

        return true;
    } catch (error) {
        console.error('Error updating comment:', error);
        return false;
    }
};



